export const getLabelPromptDelivery = (hasPromptDelivery: boolean) =>
  hasPromptDelivery ? 'pronta-entrega' : 'nao-pronta-entrega'
